/*LIBRARY*/
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FOLDER_CHILD from "./FOLDER_CHILD";
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  get_all_folder_project_list_by_user_id,
  push_project,
  pull_project,
} from "../../App/actions/folderProjectAction";
import { set_value_project } from "../../App/actions/projectActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const MOVE_PROJECT_TO_FOLDER = ({
  project,
  auth,
  get_all_folder_project_list_by_user_id,
  set_value_project,
  push_project,
  pull_project,
  toggle_move_folder,
}) => {
  const [modal_warn, set_modal_warn] = useState(false);

  const {
    folder_project_list_all = [],
    folder_id_selected_move,
    folder_object_selected_list = [],
    folder_id_selected,
    project_id_selected_move,
    geo_project,
  } = project;

  useEffect(() => {
    get_all_folder_project_list_by_user_id();
  }, [get_all_folder_project_list_by_user_id]);

  const toggle_warn = () => {
    set_modal_warn((prev) => !prev);
  };

  const on_click_folder = (folder_id) => {
    set_value_project({
      key: "folder_id_selected_move",
      value: folder_id,
    });
  };

  const on_push_project = () => {
    if (
      folder_id_selected === folder_id_selected_move ||
      !folder_id_selected_move
    ) {
      toggle_warn();
    } else {
      const key =
        folder_object_selected_list.length === 0
          ? "geo_project_list"
          : "geo_project_list_child";

      const push_body = {
        key,
        folder_id: folder_id_selected_move,
        project_id: project_id_selected_move,
      };

      push_project(push_body);
      toggle_move_folder();

      if (folder_id_selected) {
        //jika posisinya berada di dalam folder maka lakukan penghapusan project_id di folder selected, supaya satu project hanya bisa berada di satu folder
        const pull_body = {
          is_not_outside: true,
          key,
          folder_id: folder_id_selected,
          project_id: project_id_selected_move,
          geo_project: geo_project,
        };
        pull_project(pull_body);
      }
    }
  };

  const on_pull_project = () => {
    const key =
      folder_object_selected_list.length === 0
        ? "geo_project_list"
        : "geo_project_list_child";

    const body = {
      key,
      folder_id: folder_id_selected,
      project_id: project_id_selected_move,
      geo_project: geo_project,
    };

    pull_project(body);
    toggle_move_folder();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  const folder_parent_list = folder_project_list_all.filter(
    (item) => !item?.folder_parent_id,
  );

  return (
    <main>
      {modal_warn && (
        <Modal modalSize="small" isOpen={modal_warn} onClose={toggle_warn}>
          <div className="box-body" id="box-body">
            {dict?.["Please select a folder first"]?.[language]}
          </div>
        </Modal>
      )}

      <section
        className="margin_bottom"
        style={{
          maxHeight: "calc(( 70vh - 200px ))",
          height: "calc(( 70vh - 200px ))",
          overflowY: "scroll",
        }}
      >
        {folder_parent_list.map((item, idx) => {
          const folder_list_child = folder_project_list_all.filter(
            (child) => child?.folder_parent_id === item?._id,
          );

          return (
            <div key={item?._id || idx} className="margin_bottom">
              <div
                className={`container_folder background_white cursor_pointer ${
                  item._id === folder_id_selected_move
                    ? "outline_blue"
                    : "outline_grey"
                }`}
                onClick={() => on_click_folder(item?._id)}
                data-mapid={`moveTo-${idx}`}
              >
                <table className="full_width">
                  <tbody>
                    <tr>
                      <td>
                        <p
                          className="max_one_lines"
                          style={{
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        >
                          {item?.name}
                        </p>
                      </td>
                      {folder_id_selected_move === item?._id && (
                        <td className="text_right">
                          <span className="badge_circle_small background_green" />
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>

              {folder_id_selected === item?._id && (
                <div className="badge">{dict?.["Current"]?.[language]}</div>
              )}

              {folder_list_child?.length > 0 && (
                <FOLDER_CHILD
                  folder_id_selected={folder_id_selected}
                  folder_parent_id={item?._id}
                  folder_list_child={folder_list_child}
                  folder_project_list_all={folder_project_list_all}
                  on_click_folder={on_click_folder}
                  folder_id_selected_move={folder_id_selected_move}
                />
              )}
            </div>
          );
        })}
      </section>

      <section className="margin_top">
        <button
          className="button margin_right margin_bottom background_black"
          onClick={on_push_project}
          data-mapid="moveProject"
        >
          {dict?.["Move"]?.[language]}
        </button>
        {folder_object_selected_list.length > 0 && (
          <button
            className="button background_black"
            onClick={on_pull_project}
            data-mapid="clickOutFolder"
          >
            {dict?.["Remove from folder"]?.[language]}
          </button>
        )}
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  get_all_folder_project_list_by_user_id,
  set_value_project,
  push_project,
  pull_project,
})(MOVE_PROJECT_TO_FOLDER);
